// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"7924e762","84":"7924e762","456":"abaaac85","858":"234780a1","900":"234780a1","925":"234780a1"}[chunkId] + ".chunk.css";
};